export default "__VITE_ASSET__CTr0RzFc__"